import { useTranslation } from 'react-i18next';

import { NavigableAnnotationPopoverProps } from 'contexts/SchemableFormNavigationContext/SchemableFormNavigationContext';
import { WithRef } from 'support/types/withRef';
import { FieldAnnotationPopoverShell } from 'components/WebEDI/FieldAnnotationPopover/FieldAnnotationPopoverShell';

import { ProductValidationItem } from '../../helpers/productValidationErrors';

/**
 * What a cell or row shows when it is focused and the server rejected it. `DataTable` mounts this
 * for every focused cell, error or not, so it renders nothing without a message to show — which is
 * also the case for a row that is highlighted only because one of its cells is.
 */
export const ProductValidationPopover = ({
  annotation,
  style,
  ref,
}: WithRef<NavigableAnnotationPopoverProps<ProductValidationItem>, HTMLDivElement>) => {
  const { t } = useTranslation();

  if (!annotation || annotation.messages.length === 0) {
    return null;
  }

  return (
    <FieldAnnotationPopoverShell
      ref={ref}
      style={style}
      status="error"
      title={t('settings:productMasterdata.validation.popoverTitle')}
      description={annotation.messages.map((message) => (
        <span key={message} className="block">
          {message}
        </span>
      ))}
    />
  );
};
